import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, ZapIcon, ThumbsUpIcon, TrendingUpIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: CalendarIcon,
    title: 'Más Citas Agendadas',
    desc: 'Convierte prospectos mientras duermes.'
  }, {
    icon: ZapIcon,
    title: 'Respuesta Inmediata',
    desc: 'Responde en segundos, no en horas.'
  }, {
    icon: ThumbsUpIcon,
    title: 'Menos Trabajo Manual',
    desc: 'Deja de perseguir prospectos. El sistema lo hace por ti.'
  }, {
    icon: TrendingUpIcon,
    title: 'Mayor Tasa de Conversión',
    desc: 'Convierte más de los prospectos que ya tienes en clientes que pagan.'
  }];
  return <section className="py-24 bg-surface/20 border-t border-border/50" data-id="element-10">
      <div className="max-w-5xl mx-auto px-6" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-13">
            Lo Que Obtienes Con CONECKTA
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-14">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="card-hover p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-15">
              <div className="bg-primary/10 border border-primary/20 p-4 rounded-xl shrink-0" data-id="element-16">
                <benefit.icon className="w-8 h-8 text-primary" data-id="element-17" />
              </div>
              <div data-id="element-18">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-19">
                  {benefit.title}
                </h3>
                <p className="text-gray-400" data-id="element-20">{benefit.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}